<app-spinner></app-spinner>
<router-outlet></router-outlet>
<p-toast></p-toast>